import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { reportListInterface } from 'src/app/util/interfaces/reportList';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ReportHubService {
	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	private getReportListUrl = environment.baseApiUrl + 'report';
	private deleteReportListUrl = environment.baseApiUrl + 'report/{idReport}';
	private getReportDataUrl = environment.baseApiUrl + 'report/{idReport}';

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	getReportList(): Observable<reportListInterface[]> {
		return this.http.get(this.getReportListUrl, { headers: this.headers }).pipe(
			map((reportListRes: any[]) => {
				const newReportListArray: reportListInterface[] = [];
				for (const report of reportListRes) {
					const newReportList: reportListInterface = {
						id: report.id,
						name: report.report_name,
						type: report.type,
						type_label: report.type_label,
						sub_type: report.sub_type,
					};

					newReportListArray.push(newReportList);
				}

				return newReportListArray;
			})
		);
	}

	deleteReportList(idReport: string): Observable<JSON> {
		const deleteReportUrl = this.deleteReportListUrl.replace('{idReport}', idReport);
		return this.http.delete<JSON>(deleteReportUrl, { headers: this.headers });
	}

	getReportData(
		idReport: string, // Obrigatório
		type: string, // Obrigatório
		subtype: string, // Obrigatório
		getter_limit?: number,
		qryString?: string,
		getType?: string,
		idIndicator?: string,
		genericParameter1?: string,
		dateRange?: string,
		startDate?: string,
		endDate?: string
	): Observable<{ columns: mspTableHeaderI[]; data: any }> {
		// Verifica se os parâmetros obrigatórios estão presentes
		if (!idReport || !type || !subtype) {
			console.error('❌ Erro: Parâmetros obrigatórios ausentes!', { idReport, type, subtype });
			throw new Error('Parâmetros obrigatórios ausentes: idReport, type e subtype são necessários.');
		}

		// Construção da URL
		let getReportDataUrl =
			this.getReportDataUrl.replace('{idReport}', idReport) +
			`?type=${encodeURIComponent(type)}&subtype=${encodeURIComponent(subtype)}`;

		const queryParameters = [];

		if (getter_limit !== undefined && getter_limit !== null) {
			queryParameters.push(`getter_limit=${getter_limit}`);
		}

		if (qryString) {
			queryParameters.push(qryString);
		}

		if (idIndicator) {
			queryParameters.push(
				`getType=${getType}`,
				`idIndicator=${idIndicator}`,
				`genericParam1=${genericParameter1}`,
				`dateRange=${dateRange}`
			);
		}

		if (startDate && endDate) {
			queryParameters.push(`startDate=${startDate}`, `endDate=${endDate}`);
		}

		if (queryParameters.length > 0) {
			getReportDataUrl += '&' + queryParameters.join('&');
		}

		return this.http.get<any>(getReportDataUrl, { headers: this.headers });
	}
}
